export default __webpack_public_path__ + "static/media/UXG.0d1dfb56.png";